declare global {
  interface String {
    toColor(): string;
    getHexColor(): string;
    getAlpha(): number;
    capitalize(): string;
  }
}

String.prototype.getHexColor = function (this: string): string {
  if (!this.startsWith('#') || (this.length !== 9 && this.length !== 7)) {
    console.warn('Invalid color format. Expected: "#RRGGBB" or "#RRGGBBAA"');
    return this.length >= 7 ? this.substring(0, 7) : this;
  }

  return this.substring(0, 7);
};

String.prototype.getAlpha = function (this: string): number {
  if (!this.startsWith('#') || this.length !== 9) {
    console.warn('Invalid color format. Expected: "#RRGGBBAA"');
    return 1.0;
  }

  const alphaHex = this.substring(7, 9);

  return parseInt(alphaHex, 16) / 255;
};

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

export { };
